/**
 * BioHerbs dcoded-llp landing page interactions
 * No section.id coupling — uses data-dcoded-llp-* attributes only.
 */
(function () {
  'use strict';

  var PURCHASE_EVENT = 'dcoded-llp:purchase-change';
  var inited = new WeakSet();

  var RAIL_PLANS = {
    try: {
      id: 'try',
      qty: 1,
      mode: 'one_time',
      frequency: '',
      cta: 'Add to cart · £14.95',
      reassure: 'One-time · free UK delivery',
    },
    popular: {
      id: 'popular',
      qty: 1,
      mode: 'subscribe',
      frequency: '3 months',
      cta: 'Subscribe & Save · £13.46',
      reassure: 'Every 3 months · cancel anytime · free UK delivery',
    },
    max: {
      id: 'max',
      qty: 2,
      mode: 'subscribe',
      frequency: '6 months',
      cta: 'Subscribe & Save · £21.92',
      reassure: 'Every 6 months · cancel anytime · free UK delivery',
    },
  };

  var LLP_DESKTOP_MQ = '(min-width: 1024px)';

  function isLlpDesktop() {
    return typeof window.matchMedia === 'function' && window.matchMedia(LLP_DESKTOP_MQ).matches;
  }

  /** Find offer nodes even after the buy panel is moved into the desktop rail. */
  function findLlpOfferNode(root, sel) {
    if (root && root.querySelector) {
      var local = root.querySelector(sel);
      if (local) return local;
      if (root.matches && root.matches(sel)) return root;
    }
    return document.querySelector(sel);
  }

  /** Pack qty → subscribe cadence (1 pouch ≈ 3-month supply). */
  function frequencyForPackQty(qty) {
    qty = parseInt(qty, 10) || 1;
    if (qty >= 4) return '12 months';
    if (qty >= 2) return '6 months';
    return '3 months';
  }

  function markInited(el) {
    if (!el || inited.has(el)) return false;
    inited.add(el);
    return true;
  }

  /* ---------- Drag scroll ---------- */
  function enableDragScroll(scroller) {
    if (!scroller || scroller.dataset.dcodedLlpDragBound === 'true') return;
    scroller.dataset.dcodedLlpDragBound = 'true';

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;

    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      if (e.target.closest('a, button, input, label, [data-dcoded-llp-no-drag]')) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      scrollLeft = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
      try {
        scroller.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    scroller.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerType === 'touch') return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      scroller.scrollLeft = scrollLeft - dx;
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      scroller.classList.remove('is-dragging');
      if (moved && e && e.type === 'pointerup') {
        scroller.dataset.dcodedLlpSuppressClick = 'true';
        setTimeout(function () {
          delete scroller.dataset.dcodedLlpSuppressClick;
        }, 80);
      }
    }

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('pointerleave', function () {
      if (isDown) endDrag();
    });

    scroller.addEventListener(
      'click',
      function (e) {
        if (scroller.dataset.dcodedLlpSuppressClick === 'true') {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  /* ---------- Reviews ---------- */
  function initReviews(root) {
    if (!root || !markInited(root)) return;
    var track = root.querySelector('[data-dcoded-llp-reviews-track]');
    if (track) enableDragScroll(track);
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    if (!root || !markInited(root)) return;
    var track = root.querySelector('[data-dcoded-llp-gallery-track]');
    var dotsWrap = root.querySelector('[data-dcoded-llp-gallery-dots]');
    if (!track || !dotsWrap) return;

    var slides = track.querySelectorAll('[data-dcoded-llp-gallery-slide]');
    var dots = dotsWrap.querySelectorAll('[data-dcoded-llp-gallery-dot]');
    var timer;

    function setDot(i) {
      dots.forEach(function (d, k) {
        d.classList.toggle('is-on', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index'), 10) || 0;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setDot(i);
      });
    });

    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (!track.clientWidth) return;
          setDot(Math.max(0, Math.round(track.scrollLeft / track.clientWidth)));
        }, 60);
      },
      { passive: true }
    );

    enableDragScroll(track);
    setDot(0);
  }

  /* ---------- Offer / tiers ---------- */
  function publishPurchase(detail) {
    document.dispatchEvent(new CustomEvent(PURCHASE_EVENT, { detail: detail || {} }));
  }

  function showOfferError(message) {
    var el = document.querySelector('[data-dcoded-llp-offer-error]');
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function readTierData(tier) {
    return {
      id: tier.getAttribute('data-tier-id') || '',
      pouchPrice: tier.getAttribute('data-pouch-price') || '',
      stickyNote: tier.getAttribute('data-sticky-note') || '',
      stickyCta: tier.getAttribute('data-sticky-cta') || '',
      reassure: tier.getAttribute('data-reassure') || '',
      quantity: parseInt(tier.getAttribute('data-quantity'), 10) || 1,
      mode: tier.getAttribute('data-mode') || 'one_time',
      sellingPlan: tier.getAttribute('data-selling-plan') || '',
      tierIndex: parseInt(tier.getAttribute('data-tier-index'), 10) || 0,
      productHandle: tier.getAttribute('data-product-handle') || '',
    };
  }

  function setSellingPlanOnForm(form, sellingPlan) {
    var planInput = form.querySelector('[data-dcoded-llp-selling-plan]');
    if (!planInput) return;
    if (sellingPlan) {
      planInput.value = String(sellingPlan);
      planInput.setAttribute('name', 'selling_plan');
    } else {
      planInput.value = '';
      planInput.removeAttribute('name');
    }
  }

  function applyTierToForm(root, data) {
    var form = root.querySelector('[data-dcoded-llp-product-form]') || root;
    var qtyInput = form.querySelector('[data-dcoded-llp-quantity-input]');
    if (qtyInput) qtyInput.value = String(data.quantity || 1);
    setSellingPlanOnForm(form, data.sellingPlan || '');

    var purchase = root.matches('[data-dcoded-llp-purchase]')
      ? root
      : root.querySelector('[data-dcoded-llp-purchase]');
    if (purchase) {
      purchase.setAttribute('data-selected-tier', data.id || '');
      purchase.setAttribute('data-pouch-price', data.pouchPrice || '');
      purchase.setAttribute('data-sticky-note', data.stickyNote || '');
      purchase.setAttribute('data-sticky-cta', data.stickyCta || '');
      purchase.setAttribute('data-reassure', data.reassure || '');
      purchase.setAttribute('data-quantity', String(data.quantity || 1));
      purchase.setAttribute('data-mode', data.mode || 'one_time');
      purchase.setAttribute('data-selling-plan', data.sellingPlan || '');
    }
  }

  function findMoneyAll(text) {
    var matches = String(text || '').match(/(£|\$|€)\s?[\d,.]+/g) || [];
    return matches.map(function (m) {
      return m.replace(/\s+/g, '');
    });
  }

  function moneyValue(str) {
    return parseFloat(String(str || '').replace(/[^\d.]/g, '')) || 0;
  }

  /** Kaching marks compare-at as bar-full-price (struck through), not "compare". */
  var COMPARE_PRICE_SELECTOR = [
    's',
    'del',
    '[style*="line-through"]',
    '[class*="compare"]',
    '[class*="Compare"]',
    '[class*="full-price"]',
    '[class*="FullPrice"]',
    '[class*="was-price"]',
    '[class*="WasPrice"]',
    '[class*="original-price"]',
    '[class*="strike"]',
    '.kaching-bundles__bar-full-price',
  ].join(', ');

  function hasLineThrough(el) {
    var cur = el;
    for (var i = 0; i < 6 && cur && cur.nodeType === 1; i++) {
      if (cur.matches && cur.matches(COMPARE_PRICE_SELECTOR)) return true;
      try {
        var style = window.getComputedStyle(cur);
        var deco = (style && (style.textDecorationLine || style.textDecoration)) || '';
        if (String(deco).indexOf('line-through') !== -1) return true;
      } catch (err) {}
      cur = cur.parentElement;
    }
    return false;
  }

  /** Collect money strings from live DOM, skipping compare-at / struck prices. */
  function findSalePrices(root) {
    if (!root) return [];
    var found = [];
    var seen = {};
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var matches = String(node.textContent || '').match(/(£|\$|€)\s?[\d,.]+/g);
      if (!matches) continue;
      if (hasLineThrough(node.parentElement)) continue;
      matches.forEach(function (m) {
        var price = m.replace(/\s+/g, '');
        if (!seen[price]) {
          seen[price] = true;
          found.push(price);
        }
      });
    }
    return found;
  }

  function pickLargest(prices) {
    if (!prices || !prices.length) return '';
    return prices.slice().sort(function (a, b) {
      return moneyValue(b) - moneyValue(a);
    })[0];
  }

  function pickFullPackPrice(mount) {
    if (!mount) return '';

    // 1) Selected delivery-frequency card (Subscribe / One-time) — discounted total.
    var freqCard = null;
    var freqLen = Infinity;
    mount.querySelectorAll('label, [role="radio"], button, li, div, section').forEach(function (el) {
      var text = el.textContent || '';
      if (!/subscribe|one[\s-]?time/i.test(text)) return;
      if (text.length > 600) return;
      var checked =
        el.matches('[aria-checked="true"], [aria-pressed="true"], .selected, .is-selected, [class*="selected"]') ||
        !!el.querySelector('input:checked, [aria-checked="true"]');
      if (!checked) return;
      // Prefer the tightest matching card (avoids oversized wrappers).
      if (text.length < freqLen) {
        freqLen = text.length;
        freqCard = el;
      }
    });

    if (freqCard) {
      // Strip Kaching compare-at nodes, then read remaining money.
      var freqClone = freqCard.cloneNode(true);
      freqClone.querySelectorAll(COMPARE_PRICE_SELECTOR).forEach(function (node) {
        node.remove();
      });
      var freqPrices = findMoneyAll(freqClone.textContent || '');
      // Live-DOM pass also drops computed line-through (clone can't see CSS).
      var liveSale = findSalePrices(freqCard);
      if (liveSale.length) freqPrices = liveSale;

      if (freqPrices.length === 1) return freqPrices[0];
      if (freqPrices.length === 2) {
        // Frequency cards show discounted total + compare-at; take the lower (final) price.
        return moneyValue(freqPrices[0]) <= moneyValue(freqPrices[1])
          ? freqPrices[0]
          : freqPrices[1];
      }
      if (freqPrices.length > 2) return pickLargest(freqPrices);
    }

    // 2) Fallback: largest non-compare price in the whole mount.
    return pickLargest(findSalePrices(mount));
  }

  function isElSelected(el) {
    if (!el) return false;
    return (
      el.matches(
        '[aria-checked="true"], [aria-pressed="true"], [aria-selected="true"], .selected, .is-selected, [class*="selected"]'
      ) || !!el.querySelector('input:checked, [aria-checked="true"], [aria-selected="true"]')
    );
  }

  function readKachingPackQty(mount, formQty) {
    var found = 0;
    if (mount) {
      mount.querySelectorAll('label, [role="radio"], button, li, div').forEach(function (el) {
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (text.length > 220) return;
        var buyMatch = text.match(/buy\s+(\d+)\s+packs?/i);
        if (!buyMatch) return;
        if (!isElSelected(el) && !(el.querySelector && el.querySelector('input:checked'))) return;
        found = parseInt(buyMatch[1], 10) || found;
      });

      if (!found) {
        var summary = (mount.textContent || '').match(/(\d+)\s+packs?\s+repeats/i);
        if (summary) found = parseInt(summary[1], 10) || 0;
      }
    }
    return found || formQty || 1;
  }

  function readKachingFrequencyMonths(mount) {
    if (!mount) return 0;

    var months = 0;
    mount.querySelectorAll('select').forEach(function (select) {
      if (months) return;
      var opt = select.options && select.options[select.selectedIndex];
      var label = ((opt && opt.textContent) || select.value || '').replace(/\s+/g, ' ');
      if (!/month/i.test(label)) return;
      var m = label.match(/(\d+)\s*months?/i);
      if (m) months = parseInt(m[1], 10) || 0;
    });
    if (months) return months;

    var best = '';
    var bestLen = Infinity;
    mount.querySelectorAll('label, [role="radio"], button, li, div, section').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/subscribe/i.test(text) || !/every\s+\d+\s+months?/i.test(text)) return;
      if (text.length > 600) return;
      if (!isElSelected(el)) return;
      if (text.length < bestLen) {
        bestLen = text.length;
        best = text;
      }
    });

    var match = best.match(/every\s+(\d+)\s+months?/i);
    if (!match) match = (mount.textContent || '').match(/repeats?\s+every\s+(\d+)\s+months?/i);
    return match ? parseInt(match[1], 10) || 0 : 0;
  }

  function readKachingIsSubscribe(mount, sellingPlan) {
    if (!mount) return !!sellingPlan;

    var best = '';
    var bestLen = Infinity;
    mount.querySelectorAll('label, [role="radio"], button, li, div, section').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/subscribe|one[\s-]?time/i.test(text)) return;
      if (text.length > 600) return;
      if (!isElSelected(el)) return;
      if (text.length < bestLen) {
        bestLen = text.length;
        best = text;
      }
    });

    if (best) {
      if (/one[\s-]?time/i.test(best) && !/repeats?\s+every/i.test(best)) return false;
      if (/subscribe/i.test(best)) return true;
    }
    return !!sellingPlan;
  }

  function formatStickyPackNote(qty, isSubscribe, months) {
    var packLabel = String(qty || 1) + '-PACK';
    if (!isSubscribe) return packLabel + ' • ONE-TIME';
    if (months) return packLabel + ' • EVERY ' + months + ' MONTHS';
    return packLabel + ' • SUBSCRIPTION';
  }

  function syncStickyFromKachingForm(root) {
    var form = findLlpOfferNode(root, '[data-dcoded-llp-product-form]');
    if (!form) return;

    var formQty = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
    var planEl = form.querySelector('[name="selling_plan"]');
    var sellingPlan = planEl && planEl.value ? planEl.value : '';
    var mount = findLlpOfferNode(root, '[data-dcoded-llp-kaching-mount]');
    var qty = readKachingPackQty(mount, formQty);
    var isSubscribe = readKachingIsSubscribe(mount, sellingPlan);
    var months = isSubscribe ? readKachingFrequencyMonths(mount) : 0;

    // Full pack / delivery total — not the "per pack" deal-bar price.
    var price = pickFullPackPrice(mount);
    var pencePerDay = 0;
    if (price && qty) {
      // Each pouch contains a 90-day supply; calculate the selected bundle's
      // effective daily price instead of showing the static default.
      pencePerDay = Math.round((moneyValue(price) * 100) / (qty * 90));
    }
    var stickyPrice = pencePerDay ? '~' + pencePerDay + 'p' : '';

    var detail = {
      quantity: qty,
      sellingPlan: sellingPlan,
      mode: isSubscribe ? 'subscribe' : 'one_time',
      pouchPrice: price || '',
      stickyPrice: stickyPrice,
      stickyUnit: '',
      stickyNote: formatStickyPackNote(qty, isSubscribe, months),
      stickyCta: isSubscribe
        ? 'Buy Now' + (price ? ' · ' + price : '')
        : 'Add to cart' + (price ? ' · ' + price : ''),
      reassure: isSubscribe
        ? 'Subscription · cancel anytime · free UK delivery'
        : 'One-time · free UK delivery',
    };

    publishPurchase(detail);
  }

  function matchesPreferredFrequency(text, preferredFreq, preferredId) {
    var t = String(text || '');
    if (preferredId && (t === String(preferredId) || t.indexOf(String(preferredId)) !== -1)) {
      return true;
    }
    if (preferredFreq && new RegExp(String(preferredFreq).replace(/\s+/g, '\\s*'), 'i').test(t)) {
      return true;
    }
    if (preferredFreq) return false;
    return /6\s*months?/i.test(t);
  }

  function sellingPlanIdForFrequency(mount, form, preferredFreq) {
    var months = 0;
    var m = String(preferredFreq || '').match(/(\d+)\s*months?/i);
    if (m) months = parseInt(m[1], 10) || 0;
    var attr =
      months >= 12
        ? 'data-preferred-selling-plan-12m'
        : months >= 6
          ? 'data-preferred-selling-plan-6m'
          : 'data-preferred-selling-plan-3m';
    return (
      (mount && mount.getAttribute(attr)) ||
      (form && form.querySelector('[' + attr + ']') && form.querySelector('[' + attr + ']').getAttribute(attr)) ||
      (mount && mount.getAttribute('data-preferred-selling-plan')) ||
      (form &&
        form.querySelector('[data-preferred-selling-plan]') &&
        form.querySelector('[data-preferred-selling-plan]').getAttribute('data-preferred-selling-plan')) ||
      ''
    );
  }

  /**
   * Default Subscribe frequency: always 6 months (mobile + desktop).
   * Optional override.frequency kept for legacy rail sync (commented out).
   */
  function resolvePreferredFrequency(root, override) {
    var mount = findLlpOfferNode(root, '[data-dcoded-llp-kaching-mount]');
    var form = findLlpOfferNode(root, '[data-dcoded-llp-product-form]');
    if (!mount) return { freq: '6 months', id: '', key: 'fallback' };

    if (override && override.frequency) {
      var oFreq = String(override.frequency);
      return {
        freq: oFreq,
        id: sellingPlanIdForFrequency(mount, form, oFreq),
        key: 'override:' + oFreq,
      };
    }

    // Always prefer 6 months unless liquid attrs override (both already set to 6 months).
    var freq =
      mount.getAttribute('data-preferred-frequency') ||
      mount.getAttribute('data-preferred-frequency-mobile') ||
      '6 months';
    if (!/6\s*months?/i.test(freq)) freq = '6 months';
    return {
      freq: freq,
      id: sellingPlanIdForFrequency(mount, form, freq),
      key: 'default:6 months',
    };
  }

  /**
   * Custom <kaching-bundle> mounts on non-PDP pages can ignore the app default.
   * Mobile → 6 months; desktop → cadence for the selected pack.
   */
  function applyPreferredKachingFrequency(root, override) {
    var mount = findLlpOfferNode(root, '[data-dcoded-llp-kaching-mount]');
    var form = findLlpOfferNode(root, '[data-dcoded-llp-product-form]');
    if (!mount) return false;

    var resolved = resolvePreferredFrequency(root, override);
    var preferredFreq = resolved.freq;
    var preferredId = resolved.id;
    var prefKey = resolved.key;
    var lastKey = mount.getAttribute('data-dcoded-llp-plan-pref-key') || '';

    if (
      mount.getAttribute('data-dcoded-llp-plan-pref-applied') === 'true' &&
      lastKey === prefKey
    ) {
      return false;
    }

    var changed = false;

    function markApplied() {
      mount.setAttribute('data-dcoded-llp-plan-pref-applied', 'true');
      mount.setAttribute('data-dcoded-llp-plan-pref-key', prefKey);
    }

    mount.querySelectorAll('select').forEach(function (select) {
      var options = Array.prototype.slice.call(select.options || []);
      if (options.length < 2) return;
      var looksLikeFreq = options.some(function (opt) {
        return /month/i.test(opt.textContent || '') || /month/i.test(opt.value || '');
      });
      if (!looksLikeFreq) return;

      var target = null;
      options.forEach(function (opt) {
        if (target) return;
        if (matchesPreferredFrequency(opt.textContent, preferredFreq, preferredId)) target = opt;
        else if (matchesPreferredFrequency(opt.value, preferredFreq, preferredId)) target = opt;
      });
      if (!target) return;

      if (String(select.value) !== String(target.value)) {
        select.value = target.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        changed = true;
      }
      markApplied();
    });

    if (mount.getAttribute('data-dcoded-llp-plan-pref-key') === prefKey &&
        mount.getAttribute('data-dcoded-llp-plan-pref-applied') === 'true') {
      return changed;
    }

    // Custom dropdown / radio UIs — click the preferred frequency once if another is active.
    var optionNodes = mount.querySelectorAll(
      '[role="option"], [role="radio"], label, li, button, option, .kaching-bundles__option, [class*="option"]'
    );
    var preferredNode = null;
    var preferredSelected = false;
    optionNodes.forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/repeats?\s+every\s+\d+\s+months?/i.test(text) && !/every\s+\d+\s+months?/i.test(text)) {
        return;
      }
      if (text.length > 80) return;
      var selected =
        el.matches('[aria-selected="true"], [aria-checked="true"], .selected, .is-selected, [class*="selected"]') ||
        !!(el.closest && el.closest('[aria-selected="true"], [aria-checked="true"], .selected, .is-selected'));
      if (matchesPreferredFrequency(text, preferredFreq, preferredId)) {
        if (!preferredNode) preferredNode = el;
        if (selected) preferredSelected = true;
      }
    });

    if (preferredSelected) {
      markApplied();
      return false;
    }

    // Force 6-month (or preferred) option even when Kaching left another / no selection.
    if (preferredNode) {
      try {
        preferredNode.click();
        changed = true;
      } catch (err) {}
      markApplied();
      return changed;
    }

    if (preferredId && form) {
      var planInputs = form.querySelectorAll('[name="selling_plan"]');
      var currentText = mount.textContent || '';
      planInputs.forEach(function (input) {
        if (!input.value || String(input.value) === String(preferredId)) return;
        if (/\d+\s*months?/i.test(currentText)) {
          input.value = String(preferredId);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          changed = true;
          markApplied();
        }
      });
    }

    return changed;
  }

  function bindKachingStickySync(root) {
    var mount = findLlpOfferNode(root, '[data-dcoded-llp-kaching-mount]');
    var form = findLlpOfferNode(root, '[data-dcoded-llp-product-form]');
    if (!mount || !form) return;

    var schedule = function () {
      window.setTimeout(function () {
        applyPreferredKachingFrequency(root);
        syncStickyFromKachingForm(root);
      }, 50);
    };

    mount.addEventListener('click', schedule);
    mount.addEventListener('change', schedule);
    form.addEventListener('change', schedule);

    ['deal-bar-selected', 'variant-selected', 'variants-changed'].forEach(function (evt) {
      mount.addEventListener(evt, schedule);
      document.addEventListener(evt, schedule);
    });

    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(schedule);
      obs.observe(mount, { childList: true, subtree: true, attributes: true });
      setTimeout(function () {
        obs.disconnect();
      }, 15000);
    }

    // Retry while Kaching hydrates its frequency dropdown.
    var tries = 0;
    var boot = window.setInterval(function () {
      tries += 1;
      applyPreferredKachingFrequency(root);
      syncStickyFromKachingForm(root);
      if (mount.getAttribute('data-dcoded-llp-plan-pref-applied') === 'true' || tries >= 40) {
        window.clearInterval(boot);
      }
    }, 250);

    schedule();
  }

  function hideMorePaymentOptions(scope) {
    var root = scope || document;
    root.querySelectorAll('.shopify-payment-button__more-options').forEach(function (el) {
      el.setAttribute('hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function initOffer(root) {
    if (!root || !markInited(root)) return;

    var kachingVisible = root.getAttribute('data-kaching-visible') === 'true';
    var tiers = root.querySelectorAll('[data-dcoded-llp-tier]');

    if (!kachingVisible && tiers.length) {
      function selectTier(tier) {
        tiers.forEach(function (t) {
          var on = t === tier;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var data = readTierData(tier);
        applyTierToForm(root, data);
        publishPurchase(data);
      }

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function () {
          selectTier(tier);
        });
        tier.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectTier(tier);
          }
        });
      });

      var selected = root.querySelector('[data-dcoded-llp-tier].is-selected') || tiers[0];
      if (selected) selectTier(selected);
    }

    // When Kaching UI is the selector, follow its form state for sticky copy.
    if (kachingVisible) {
      bindKachingStickySync(root);
    }

    bindBuyNowButtons(root);
  }

  function bindBuyNowButtons(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-dcoded-bbp-buy-now]').forEach(function (btn) {
      if (btn.dataset.dcodedBbpBuyNowBound === 'true') return;
      btn.dataset.dcodedBbpBuyNowBound = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addOfferToCart(btn);
      });
    });
  }

  /* ---------- Sticky CTA ---------- */
  function isAtKachingBundle() {
    if (isLlpDesktop()) {
      var p2 = document.getElementById('p2');
      if (p2) return p2.getBoundingClientRect().top <= window.innerHeight * 0.65;
    }

    var mount = document.querySelector('[data-dcoded-llp-kaching-mount]');
    if (mount) {
      var rect = mount.getBoundingClientRect();
      return rect.top <= window.innerHeight * 0.72 && rect.bottom > 0;
    }

    var buy = document.getElementById('dcoded-llp-buy') || document.querySelector('#buy');
    if (buy) return buy.getBoundingClientRect().top <= window.innerHeight * 0.72;

    return false;
  }

  function updateStickyUI(sticky, detail) {
    if (!sticky || !detail) return;
    var priceEl = sticky.querySelector('[data-dcoded-llp-sticky-price]');
    var unitEl = sticky.querySelector('[data-dcoded-llp-sticky-unit]');
    var noteEl = sticky.querySelector('[data-dcoded-llp-sticky-note]');
    var reassureEl = sticky.querySelector('[data-dcoded-llp-sticky-reassure]');
    var ctaLabelEl = sticky.querySelector('[data-dcoded-llp-sticky-cta-label]');

    // Update the sticky copy when the selected Kaching bundle changes.
    if (sticky.getAttribute('data-sync-price') === 'true') {
      if (priceEl && detail.stickyPrice) priceEl.textContent = detail.stickyPrice;
      if (unitEl) {
        unitEl.textContent = typeof detail.stickyUnit === 'string' ? detail.stickyUnit : '';
        unitEl.hidden = !unitEl.textContent;
      }
      if (noteEl) {
        if (detail.stickyNote) {
          noteEl.textContent = String(detail.stickyNote).replace(/•/g, '·');
          noteEl.hidden = false;
        } else {
          noteEl.textContent = '';
          noteEl.hidden = true;
        }
      }
    }
    if (sticky.getAttribute('data-sync-cta') === 'true' && ctaLabelEl && detail.stickyCta) {
      ctaLabelEl.textContent = detail.stickyCta;
    }
    if (reassureEl && detail.reassure && sticky.getAttribute('data-sync-reassure') === 'true') {
      reassureEl.textContent = detail.reassure;
    }
  }

  function headerOffset() {
    var hdr = document.querySelector('[data-dcoded-llp-header], .dcoded-llp-7r .dcoded-llp-hdr');
    if (!hdr) return 72;
    return Math.ceil(hdr.getBoundingClientRect().height) + 10;
  }

  function resolveNavTarget(id) {
    if (!id) return null;
    if (id === 'buy' || id === 'dcoded-llp-buy') {
      return resolveBuyTarget();
    }
    if (id === 'reasons' || id === 'the-reasons') id = 'p1';
    var target = document.getElementById(id);
    if (target) return target;
    // Fallback: first reason article
    if (id === 'p1') {
      return (
        document.querySelector('.dcoded-llp-7r .dcoded-llp-list .dcoded-llp-item') ||
        document.querySelector('article.dcoded-llp-item')
      );
    }
    return null;
  }

  /** Desktop: scroll to p2 so sticky rail + Kaching stay revealed. Mobile: mid-CTA Kaching. */
  function resolveBuyTarget() {
    if (isLlpDesktop()) {
      var rail = document.querySelector('[data-dcoded-llp-rail]');
      if (rail) rail.classList.add('dcoded-llp-on');
      // Rail only stays visible once p2 reaches the top (see initRail onScroll).
      // Scroll there — not the rail node itself (its sticky layout pos is near page top).
      return (
        document.getElementById('p2') ||
        document.querySelector('[data-dcoded-llp-rail-offer-slot].is-filled') ||
        document.querySelector('[data-dcoded-llp-offer-buy-panel]') ||
        document.querySelector('[data-dcoded-llp-rail]')
      );
    }
    return (
      document.querySelector('[data-dcoded-llp-midcta-buy-slot].is-filled') ||
      document.getElementById('dcoded-llp-midcta') ||
      document.querySelector('#dcoded-llp-buy') ||
      document.querySelector('#buy')
    );
  }

  function smoothScrollToEl(el, e) {
    if (!el) return false;
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    try {
      if (el.id) {
        history.replaceState(null, '', '#' + el.id);
      }
    } catch (err) {}
    return true;
  }

  function scrollToBuy(e) {
    var ok = smoothScrollToEl(resolveBuyTarget(), e);
    if (isLlpDesktop()) {
      var rail = document.querySelector('[data-dcoded-llp-rail]');
      if (rail) {
        rail.classList.add('dcoded-llp-on');
        // Re-apply after smooth scroll so onScroll mid-flight doesn't hide Kaching.
        window.setTimeout(function () {
          rail.classList.add('dcoded-llp-on');
        }, 450);
        window.setTimeout(function () {
          rail.classList.add('dcoded-llp-on');
        }, 900);
      }
    }
    return ok;
  }

  function initHeaderNav(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-dcoded-llp-nav-scroll], .dcoded-llp-hdrnav a[href^="#"], .dcoded-llp-rjump a[href^="#"]').forEach(function (link) {
      if (link.dataset.dcodedLlpNavBound === 'true') return;
      link.dataset.dcodedLlpNavBound = 'true';
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var id = href.slice(1);
        if (id === 'buy' || id === 'dcoded-llp-buy' || link.hasAttribute('data-dcoded-llp-scroll-buy')) {
          scrollToBuy(e);
          return;
        }
        var target = resolveNavTarget(id);
        if (!target) return;
        smoothScrollToEl(target, e);
      });
    });
  }

  function initBuyScrollLinks(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-dcoded-llp-scroll-buy], a[href="#dcoded-llp-buy"], a[href="#buy"]').forEach(function (link) {
      if (link.dataset.dcodedLlpScrollBound === 'true') return;
      if (link.hasAttribute('data-dcoded-llp-rail-cta') || link.id === 'railCta') return;
      link.dataset.dcodedLlpScrollBound = 'true';
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href') || '';
        if (
          href === '#dcoded-llp-buy' ||
          href === '#buy' ||
          link.hasAttribute('data-dcoded-llp-scroll-buy')
        ) {
          scrollToBuy(e);
        }
      });
    });
  }

  function checkoutUrl() {
    var root =
      (window.routes && window.routes.root) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'checkout';
  }

  function cartAddUrl() {
    var url =
      (window.routes && window.routes.cart_add_url) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add'
        : '/cart/add');
    if (url.indexOf('.js') === -1) url += '.js';
    return url;
  }

  function resetStickyCtas() {
    document.querySelectorAll('[data-dcoded-llp-sticky-cta], [data-dcoded-bbp-buy-now]').forEach(function (cta) {
      cta.removeAttribute('aria-disabled');
      cta.removeAttribute('disabled');
      cta.classList.remove('is-loading');
    });
  }

  function prepareFormData(form) {
    // Drop empty selling_plan so one-time purchases don't fail.
    var plans = form.querySelectorAll('[name="selling_plan"]');
    plans.forEach(function (input) {
      if (!input.value) input.removeAttribute('name');
    });

    var ourPlan = form.querySelector('[data-dcoded-llp-selling-plan]');
    if (ourPlan && !ourPlan.value) ourPlan.removeAttribute('name');

    return new FormData(form);
  }

  function addOfferToCart(cta) {
    var form = document.querySelector('[data-dcoded-llp-product-form]');
    if (!form) {
      var buy = document.querySelector('#dcoded-llp-buy');
      if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else if (cta && cta.getAttribute('data-fallback-href')) {
        window.location.href = cta.getAttribute('data-fallback-href');
      }
      return Promise.resolve(false);
    }

    showOfferError('');
    resetStickyCtas();

    var formData = prepareFormData(form);
    var variantId = formData.get('id');
    if (!variantId) {
      showOfferError('Product variant is missing. Assign the Berberine product in the Offer section.');
      return Promise.resolve(false);
    }

    if (cta) {
      cta.setAttribute('aria-disabled', 'true');
      cta.classList.add('is-loading');
    }

    // Use FormData (not JSON) so Kaching-injected fields/properties are preserved.
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, status: response.status, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || (result.data && result.data.status)) {
          var msg =
            (result.data && (result.data.description || result.data.message)) ||
            'Could not add to cart. Check your Kaching plan selection and try again.';
          console.error('[dcoded-llp] cart add error', result.data);
          showOfferError(msg);
          resetStickyCtas();
          return false;
        }
        // Re-enable before leaving so browser back / bfcache doesn't restore a dead button.
        resetStickyCtas();
        window.location.href = checkoutUrl();
        return true;
      })
      .catch(function (err) {
        console.error('[dcoded-llp] cart add failed', err);
        showOfferError('Could not add to cart. Please try again.');
        resetStickyCtas();
        return false;
      });
  }

  function initSticky(root) {
    if (!root || !markInited(root)) return;

    var introPrice = root.getAttribute('data-sticky-price') || '~16p';
    var introUnit = root.getAttribute('data-sticky-unit') || 'a day';
    var introNote = root.getAttribute('data-sticky-note') || '';
    var lastPurchaseDetail = {};
    var bundleSeen = false;

    function stickyDetailForMode(detail) {
      var merged = detail || lastPurchaseDetail || {};

      if (bundleSeen && (merged.pouchPrice || merged.stickyPrice)) {
        return {
          pouchPrice: merged.pouchPrice,
          stickyPrice: merged.pouchPrice || merged.stickyPrice || '',
          stickyUnit: '',
          stickyNote: merged.stickyNote || '',
          stickyCta: merged.stickyCta,
          reassure: merged.reassure,
        };
      }

      return {
        stickyPrice: introPrice,
        stickyUnit: introUnit,
        stickyNote: introNote,
      };
    }

    function applyStickyDisplay(detail) {
      updateStickyUI(root, stickyDetailForMode(detail));
    }

    var onPurchaseChange = function (event) {
      lastPurchaseDetail = event.detail || {};
      applyStickyDisplay(lastPurchaseDetail);
    };

    function onScroll() {
      // Visible for the whole page from first visit.
      root.classList.add('is-visible');
      if (isAtKachingBundle()) bundleSeen = true;
      root.setAttribute('data-bundle-price-mode', bundleSeen ? 'true' : 'false');
      applyStickyDisplay(lastPurchaseDetail);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener(PURCHASE_EVENT, onPurchaseChange);
    onScroll();

    root._dcodedLlpCleanup = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      document.removeEventListener(PURCHASE_EVENT, onPurchaseChange);
      inited.delete(root);
    };
  }

  /* ---------- Desktop rail (sticky card + jump-nav) ---------- */
  function normalizeUiText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function clickKachingNode(el) {
    if (!el) return false;
    try {
      el.click();
    } catch (err) {}
    var input = el.querySelector && el.querySelector('input');
    if (input && !input.checked) {
      try {
        input.click();
      } catch (err2) {}
    }
    var dealHost =
      (el.closest && el.closest('[data-deal-bar-id], [data-dealbarid]')) || el;
    var dealBarId =
      dealHost.getAttribute('data-deal-bar-id') || dealHost.getAttribute('data-dealbarid') || '';
    if (dealBarId) {
      try {
        el.dispatchEvent(
          new CustomEvent('deal-bar-selected', {
            bubbles: true,
            detail: { dealBarId: dealBarId },
          })
        );
      } catch (err3) {}
    }
    return true;
  }

  function clickBestKachingNode(mount, matcher, opts) {
    if (!mount || typeof matcher !== 'function') return false;
    opts = opts || {};
    var maxLen = opts.maxLen || 280;
    var requireExclusive = !!opts.requireExclusive;
    var best = null;
    var bestLen = Infinity;
    mount.querySelectorAll('label, [role="radio"], [role="button"], button, li, div, [role="option"]').forEach(function (el) {
      var text = normalizeUiText(el.textContent);
      if (!text || text.length > maxLen) return;
      if (!matcher(text, el)) return;
      if (requireExclusive && opts.exclusivePattern) {
        var hits = text.match(opts.exclusivePattern) || [];
        if (hits.length !== 1) return;
      }
      if (text.length < bestLen) {
        bestLen = text.length;
        best = el;
      }
    });
    return clickKachingNode(best);
  }

  function clickKachingPackQty(mount, qty) {
    var packRe = /buy\s+(\d+)\s+packs?/i;
    return clickBestKachingNode(
      mount,
      function (text) {
        var buyMatch = text.match(packRe);
        return !!(buyMatch && parseInt(buyMatch[1], 10) === qty);
      },
      { maxLen: 220, requireExclusive: true, exclusivePattern: /buy\s+\d+\s+packs?/gi }
    );
  }

  function clickKachingPurchaseMode(mount, wantSubscribe) {
    if (wantSubscribe) {
      return clickBestKachingNode(
        mount,
        function (text) {
          return /subscribe/i.test(text) && !/one[\s-]?time/i.test(text);
        },
        { maxLen: 420 }
      );
    }
    return clickBestKachingNode(
      mount,
      function (text) {
        return /one[\s-]?time/i.test(text) && !/repeats?\s+every/i.test(text);
      },
      { maxLen: 280 }
    );
  }

  function kachingMatchesPlan(mount, form, plan) {
    if (!mount || !plan) return false;
    var formQty = parseInt((form && form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
    var planEl = form && form.querySelector('[name="selling_plan"]');
    var sellingPlan = planEl && planEl.value ? planEl.value : '';
    var qty = readKachingPackQty(mount, formQty);
    var isSubscribe = readKachingIsSubscribe(mount, sellingPlan);
    var wantSubscribe = plan.mode === 'subscribe';
    var wantQty = parseInt(plan.qty, 10) || 1;
    return qty === wantQty && !!isSubscribe === !!wantSubscribe;
  }

  /**
   * Kaching re-renders on frequency changes and drops a same-tick pack click.
   * Apply mode → frequency → pack in sequence, with pack last + retries.
   */
  function syncKachingFromRailPlan(plan) {
    if (!plan) return false;
    var offer = document.querySelector('[data-dcoded-llp-offer]');
    var mount =
      (offer && offer.querySelector('[data-dcoded-llp-kaching-mount]')) ||
      document.querySelector('[data-dcoded-llp-kaching-mount]');
    var form =
      (offer && offer.querySelector('[data-dcoded-llp-product-form]')) ||
      document.querySelector('[data-dcoded-llp-product-form]');
    if (!mount) return false;

    var qty = parseInt(plan.qty, 10) || 1;
    var wantSubscribe = plan.mode === 'subscribe';
    syncKachingFromRailPlan._seq = (syncKachingFromRailPlan._seq || 0) + 1;
    var seq = syncKachingFromRailPlan._seq;

    function stillCurrent() {
      return syncKachingFromRailPlan._seq === seq;
    }

    function syncFormQty() {
      if (!form) return;
      var qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput && String(qtyInput.value) !== String(qty)) {
        qtyInput.value = String(qty);
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function finish() {
      if (!stillCurrent()) return;
      syncFormQty();
      if (offer) syncStickyFromKachingForm(offer);
    }

    function applyPack(attempt) {
      if (!stillCurrent()) return;
      if (kachingMatchesPlan(mount, form, plan) || attempt > 6) {
        finish();
        return;
      }
      clickKachingPackQty(mount, qty);
      syncFormQty();
      window.setTimeout(function () {
        applyPack(attempt + 1);
      }, 160);
    }

    function applyFrequencyThenPack() {
      if (!stillCurrent()) return;
      if (wantSubscribe) {
        if (offer) {
          mount.removeAttribute('data-dcoded-llp-plan-pref-applied');
          mount.removeAttribute('data-dcoded-llp-plan-pref-key');
          applyPreferredKachingFrequency(offer, {
            frequency: plan.frequency || frequencyForPackQty(qty),
          });
        } else {
          var freqRe = new RegExp(
            String(plan.frequency || frequencyForPackQty(qty)).replace(/\s+/g, '\\s*'),
            'i'
          );
          clickBestKachingNode(mount, function (text) {
            return freqRe.test(text);
          });
        }
      }
      // Pack last — after Kaching finishes frequency re-render.
      window.setTimeout(function () {
        applyPack(0);
      }, 220);
    }

    function applyModeThenFrequency() {
      if (!stillCurrent()) return;
      var formQty = parseInt((form && form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
      var planEl = form && form.querySelector('[name="selling_plan"]');
      var sellingPlan = planEl && planEl.value ? planEl.value : '';
      var alreadySubscribe = readKachingIsSubscribe(mount, sellingPlan);
      if (!!alreadySubscribe !== !!wantSubscribe) {
        clickKachingPurchaseMode(mount, wantSubscribe);
      }
      window.setTimeout(applyFrequencyThenPack, 200);
    }

    applyModeThenFrequency();
    return true;
  }
  syncKachingFromRailPlan._seq = 0;

  /* ---------- Host Kaching buy panel: desktop rail / mobile mid-CTA ---------- */
  function placeOfferBuyPanelInRail() {
    var panel = document.querySelector('[data-dcoded-llp-offer-buy-panel]');
    var home = document.querySelector('[data-dcoded-llp-offer-buy-home]');
    var railSlot = document.querySelector('[data-dcoded-llp-rail-offer-slot]');
    var midSlot = document.querySelector('[data-dcoded-llp-midcta-buy-slot]');
    var midcta = document.querySelector('[data-dcoded-llp-midcta]');
    var offer = document.querySelector('[data-dcoded-llp-offer]');
    if (!panel || !home) return;

    function clearHostClasses() {
      if (railSlot) {
        railSlot.classList.remove('is-filled', 'dcoded-llp-offer', 'dcoded-llp-offer--kaching-visible');
      }
      if (midSlot) midSlot.classList.remove('is-filled', 'dcoded-llp-offer', 'dcoded-llp-offer--kaching-visible');
      if (midcta) midcta.classList.remove('is-buy-hosted');
      if (offer) {
        offer.classList.remove('is-rail-hosted', 'is-midcta-hosted');
      }
    }

    function reapplyPlanPref() {
      window.setTimeout(function () {
        var mount = findLlpOfferNode(offer, '[data-dcoded-llp-kaching-mount]');
        if (mount) {
          mount.removeAttribute('data-dcoded-llp-plan-pref-applied');
          mount.removeAttribute('data-dcoded-llp-plan-pref-key');
        }
        applyPreferredKachingFrequency(offer || panel);
      }, 120);
    }

    function sync() {
      clearHostClasses();
      if (isLlpDesktop() && railSlot) {
        if (panel.parentElement !== railSlot) {
          railSlot.appendChild(panel);
        }
        railSlot.classList.add('is-filled', 'dcoded-llp-offer', 'dcoded-llp-offer--kaching-visible');
        if (offer) offer.classList.add('is-rail-hosted');
        reapplyPlanPref();
      } else if (midSlot) {
        if (panel.parentElement !== midSlot) {
          midSlot.appendChild(panel);
        }
        midSlot.classList.add('is-filled', 'dcoded-llp-offer', 'dcoded-llp-offer--kaching-visible');
        if (midcta) midcta.classList.add('is-buy-hosted');
        if (offer) offer.classList.add('is-midcta-hosted');
        reapplyPlanPref();
        hideMorePaymentOptions(midSlot);
      } else if (panel.parentElement !== home) {
        home.appendChild(panel);
      }
      hideMorePaymentOptions(panel);
    }

    sync();
    if (!placeOfferBuyPanelInRail._bound) {
      placeOfferBuyPanelInRail._bound = true;
      window.addEventListener('resize', sync, { passive: true });
    }
  }

  /* Legacy mock rail card — kept for reference; slot hosts Kaching instead.
  function initDesktopRailCard(root) {
    if (!root || root.getAttribute('data-dcoded-llp-rail-card-bound') === 'true') return;
    var card = root.querySelector('[data-dcoded-llp-rail-card]') || root.querySelector('.dcoded-llp-rbox');
    if (!card) return;
    root.setAttribute('data-dcoded-llp-rail-card-bound', 'true');

    var tiers = card.querySelectorAll('.dcoded-llp-rtier[data-id]');
    var cta = card.querySelector('#railCta') || card.querySelector('[data-dcoded-llp-rail-cta]');
    var reassure = card.querySelector('#railReassure');
    var selectedId = 'max';

    function planFor(id) {
      return RAIL_PLANS[id] || RAIL_PLANS.max;
    }

    function selectTier(id) {
      var plan = planFor(id);
      selectedId = plan.id;
      tiers.forEach(function (tier) {
        tier.classList.toggle('dcoded-llp-sel', tier.getAttribute('data-id') === selectedId);
      });
      if (cta) cta.innerHTML = plan.cta;
      if (reassure) reassure.textContent = plan.reassure;
    }

    tiers.forEach(function (tier) {
      var activate = function () {
        selectTier(tier.getAttribute('data-id'));
      };
      tier.addEventListener('click', activate);
      tier.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate();
        }
      });
    });

    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        var plan = planFor(selectedId);
        scrollToBuy(e);
        window.setTimeout(function () {
          syncKachingFromRailPlan(plan);
        }, 350);
      });
    }

    var preselected = card.querySelector('.dcoded-llp-rtier.dcoded-llp-sel');
    selectTier((preselected && preselected.getAttribute('data-id')) || 'max');
  }
  */

  function initRail(root) {
    if (!root || !markInited(root)) return;
    // initDesktopRailCard(root); // legacy mock card
    placeOfferBuyPanelInRail();

    var links = root.querySelectorAll('.dcoded-llp-rjump a[href^="#"]');
    var items = [];
    links.forEach(function (a) {
      var id = (a.getAttribute('href') || '').slice(1);
      var el = id ? document.getElementById(id) : null;
      if (el) items.push({ a: a, el: el });
    });

    function onScroll() {
      var reveal = document.getElementById('p2');
      var on = false;
      if (reveal) {
        on = reveal.getBoundingClientRect().top <= 120;
      } else {
        on = window.scrollY > 500;
      }
      root.classList.toggle('dcoded-llp-on', on);

      var best = null;
      var bestDist = Infinity;
      items.forEach(function (it) {
        var top = it.el.getBoundingClientRect().top;
        var dist = Math.abs(top - 110);
        if (top <= 160 && dist < bestDist) {
          bestDist = dist;
          best = it;
        }
      });
      items.forEach(function (it) {
        it.a.classList.toggle('dcoded-llp-act', best && it === best);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Boot ---------- */
  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-dcoded-llp-reviews]').forEach(initReviews);
    root.querySelectorAll('[data-dcoded-llp-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-dcoded-llp-offer]').forEach(initOffer);
    root.querySelectorAll('[data-dcoded-llp-sticky]').forEach(initSticky);
    root.querySelectorAll('[data-dcoded-llp-rail]').forEach(initRail);
    placeOfferBuyPanelInRail();
    initHeaderNav(root);
    initBuyScrollLinks(document);
    bindBuyNowButtons(document);
  }

  function onSectionLoad(e) {
    var el = e.target;
    if (!el || !el.querySelector) return;
    initAll(el);
  }

  function onSectionUnload(e) {
    var el = e.target;
    if (!el) return;
    var sticky = el.querySelector('[data-dcoded-llp-sticky]');
    if (sticky && typeof sticky._dcodedLlpCleanup === 'function') {
      sticky._dcodedLlpCleanup();
    }
    el.querySelectorAll('[data-dcoded-llp-reviews], [data-dcoded-llp-gallery], [data-dcoded-llp-offer], [data-dcoded-llp-sticky]').forEach(
      function (node) {
        inited.delete(node);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Browser back from checkout often restores bfcache with the CTA still disabled.
  window.addEventListener('pageshow', function () {
    resetStickyCtas();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetStickyCtas();
  });

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
  document.addEventListener('shopify:block:select', onSectionLoad);

  window.DcodedLlp = {
    initAll: initAll,
    initReviews: initReviews,
    initGallery: initGallery,
    initOffer: initOffer,
    initSticky: initSticky,
    initRail: initRail,
    placeOfferBuyPanelInRail: placeOfferBuyPanelInRail,
    // initDesktopRailCard: initDesktopRailCard, // legacy mock card
    addOfferToCart: addOfferToCart,
  };
})();
